import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {AccountInterfaceData, AccountInterfacePostData } from '../shared/models/account.model';

import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  post(endpoint: string, data) {
    return this.http.post(`${this.url}/${endpoint}`, data,{observe: 'response'});
  }

} //
